export default function Trust() {
  const testimonials = [
    {
      name: 'Marc Dubois',
      role: 'CEO, TechVision',
      content: 'AI Exécutif Assistant a transformé ma façon de travailler. Je récupère 3 heures par jour pour me concentrer sur la croissance de l\'entreprise.',
      avatar: 'https://public.readdy.ai/ai/img_res/8cafddc8a740430a817e7606c67f960f.jpg'
    },
    {
      name: 'Sophie Laurent',
      role: 'Fondatrice, Innov Conseil',
      content: 'La qualité de suivi client s\'est considérablement améliorée. Aucune relance n\'est oubliée, mes clients sont impressionnés par ma réactivité.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20business%20founder%20portrait%20in%20elegant%20attire%20with%20warm%20smile%20in%20contemporary%20office%20with%20purple%20blue%20lighting%20executive%20headshot%20photography&width=200&height=200&seq=testimonial-sophie&orientation=squarish'
    },
    {
      name: 'Thomas Mercier',
      role: 'Directeur Associé, Archi+',
      content: 'Indispensable pour gérer plusieurs projets simultanément. L\'IA comprend mes priorités et organise mon agenda de façon optimale.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20architect%20director%20portrait%20in%20modern%20business%20casual%20attire%20with%20creative%20expression%20in%20stylish%20office%20with%20purple%20blue%20ambient%20lighting%20professional%20headshot&width=200&height=200&seq=testimonial-thomas&orientation=squarish'
    }
  ];

  return (
    <section className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-violet-600/5 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ils ont déjà fait
            <br />
            <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
              le choix de l'efficacité
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:border-violet-500/50 transition-all cursor-pointer"
            >
              <div className="flex items-center mb-6">
                <div className="w-14 h-14 overflow-hidden rounded-full mr-4 flex-shrink-0">
                  <img 
                    src={testimonial.avatar} 
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-semibold">{testimonial.name}</div>
                  <div className="text-sm text-gray-400">{testimonial.role}</div>
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed italic">"{testimonial.content}"</p>
              <div className="flex mt-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-violet-600/10 to-blue-600/10 border border-violet-500/30 rounded-xl p-6 text-center">
            <i className="ri-shield-check-line text-3xl text-violet-400 mb-3"></i>
            <h3 className="font-semibold mb-2 whitespace-nowrap">Sans engagement</h3>
            <p className="text-sm text-gray-400">Testez sans risque</p>
          </div>
          <div className="bg-gradient-to-br from-violet-600/10 to-blue-600/10 border border-violet-500/30 rounded-xl p-6 text-center">
            <i className="ri-rocket-line text-3xl text-blue-400 mb-3"></i>
            <h3 className="font-semibold mb-2 whitespace-nowrap">Déploiement rapide</h3>
            <p className="text-sm text-gray-400">Opérationnel en 48h</p>
          </div>
          <div className="bg-gradient-to-br from-violet-600/10 to-blue-600/10 border border-violet-500/30 rounded-xl p-6 text-center">
            <i className="ri-lock-line text-3xl text-violet-400 mb-3"></i>
            <h3 className="font-semibold mb-2 whitespace-nowrap">Confidentiel</h3>
            <p className="text-sm text-gray-400">Données sécurisées</p>
          </div>
        </div>
      </div>
    </section>
  );
}